import { useNavigate } from "react-router-dom";
import { posts } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import PostForm from "../components/posts/PostForm";

export default function CreatePostPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSubmit = async (data) => {
    const result = await posts.create({ ...data, author_id: user.id });
    navigate(`/posts/${result.id}`);
  };

  return (
    <div>
      <PostForm onSubmit={handleSubmit} submitLabel="Publish Post" />
    </div>
  );
}
